/* Index's two string helpers. No DOM, no Lit, no React — pure string work.

   Moved out of web/src/workspace/g-index/kinds.ts in Phase 5 of the native
   client, for the reason text.ts states in its own header: two clients, one
   implementation, rather than two that drift. The drift here would be
   invisible rather than loud — a mobile copy whose separator class or
   capitalisation rule fell one character behind the web's would render the
   same 1,320 rows slightly differently on the two screens, and nothing would
   fail. Read packages/core/README.md before adding an import: this package
   stays dependency-free and its relative imports stay extensionless. */

/**
 * `"stock_or_fund"` → `"Stock or fund"`. `""` → `"All"`, which is the empty
 * chip rather than a missing value.
 *
 * The server enum (`analyze.py:MENTION_KINDS`, 21 values) is the source of
 * truth and this derives from it. A hand-written display map is the thing not
 * to build: `analyze.py` coerces any unrecognised kind to `"other"` rather
 * than dropping it, so the enum can grow without a client release, and a map
 * would silently render a new kind as nothing at all.
 */
export function prettyKind(kind: string): string {
  if (!kind) return 'All';
  const s = kind.replace(/_/g, ' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
}

const escapeRe = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Drop a leading restatement of the entry's own name from its description.
 *
 * Gemini writes roughly half of these as "Excel — spreadsheet software used to
 * host the model", so on a row that already headlines the name the prefix is
 * read twice. Measured on the live library: 683 of 1,320 rows.
 *
 * Presentational only. Search still matches the RAW detail, so typing a name
 * keeps working even where the name has been trimmed out of what's on screen.
 */
export function trimNamePrefix(name: string, detail: string): string {
  if (!name || !detail) return detail;
  const stripped = detail.replace(new RegExp(`^${escapeRe(name)}\\s*[—–:-]\\s*`, 'i'), '');
  if (stripped === detail) return detail;
  // Removing "Excel — " leaves a lowercase opener mid-row; re-capitalise.
  return stripped.charAt(0).toUpperCase() + stripped.slice(1);
}
